/*
 * Mg Theme — Pricing utilities
 * (c) 2026 NAMY SOLUTIONS LLC -- All Rights Reserved.
 *
 * Pure helpers shared across tier-card variants (qty-break, bundle-offer)
 * and future consumers (cross-sell, upsell). Zero DOM, zero side effects.
 */
(function (global) {
  'use strict';
  var Mg = (global.Mg = global.Mg || {});

  Mg.pricing = {
    /**
     * Apply percentage or fixed discount to a base price (cents).
     * @param {number} basePrice - price in cents
     * @param {string} type      - 'none' | 'percentage' | 'fixed'
     * @param {number} pct       - percentage (0-100)
     * @param {string} fixedRaw  - fixed amount in currency units (comma or dot decimal)
     * @returns {number} discounted price (cents, floored at 0)
     */
    applyDiscount: function (basePrice, type, pct, fixedRaw) {
      // Always returns INTEGER cents so JS == Liquid (which now rounds the
      // percentage path too) and no fractional cents leak into formatMoney.
      // Formula `round(base * (100 - pct) / 100)` matches the Liquid
      // `total | times: (100 - pct) | divided_by: 100.0 | round` exactly.
      if (type === 'percentage' && pct > 0) {
        return Math.max(0, Math.round(basePrice * (100 - pct) / 100));
      }
      if (type === 'fixed' && fixedRaw && fixedRaw !== '0') {
        // Tolerate a currency symbol/space a merchant may type (e.g. "€5", "5 €"):
        // strip everything but digits and the decimal point so a LEADING symbol
        // doesn't break parseFloat (mirrors snippets/mg-amount-to-cents.liquid,
        // which fixes the same bug in the server-rendered price).
        var clean = String(fixedRaw).replace(',', '.').replace(/[^\d.]/g, '');
        var cents = Math.round((parseFloat(clean) || 0) * 100);
        return Math.max(0, basePrice - cents);
      }
      return basePrice;
    },

    /**
     * Whether a variant has enough stock for the requested qty.
     * Respects 'continue' inventory policy (oversell allowed).
     * @param {object} variant - Shopify variant JSON
     * @param {number} qty
     * @returns {boolean}
     */
    isVariantAvailableForQty: function (variant, qty) {
      if (!variant) return false;
      if (!variant.inventory_management) return variant.available !== false;
      if (variant.inventory_policy === 'continue') return true;
      return variant.available && variant.inventory_quantity >= qty;
    }
  };
})(window);
